function StaffTeaching() {
  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-10 text-center">
          Staff (Teaching)
        </h2>

        {/* Table */}
        <div className="overflow-hidden rounded-2xl shadow-lg border">
          <table className="w-full text-left border-collapse">

            <thead className="bg-blue-900 text-white">
              <tr>
                <th className="px-6 py-4">Sl No</th>
                <th className="px-6 py-4">Information</th>
                <th className="px-6 py-4">Details</th>
              </tr>
            </thead>

            <tbody>

              {/* Principal */}
              <tr className="border-t bg-white hover:bg-yellow-50 transition">
                <td className="px-6 py-4 font-semibold text-blue-900">1</td>
                <td className="px-6 py-4 font-medium text-gray-700">
                  Principal
                </td>
                <td className="px-6 py-4 text-gray-800">1</td>
              </tr>

              {/* Total Teachers */}
              <tr className="border-t bg-gray-50 hover:bg-yellow-50 transition">
                <td className="px-6 py-4 font-semibold text-blue-900">2</td>
                <td className="px-6 py-4 font-medium text-gray-700">
                  Total No. of Teachers
                </td>
                <td className="px-6 py-4 text-gray-800 font-semibold">
                  64
                </td>
              </tr>

              {/* PGT */}
              <tr className="border-t bg-white hover:bg-yellow-50 transition">
                <td className="px-6 py-4"></td>
                <td className="px-6 py-4 text-gray-600 pl-10">
                  • PGT
                </td>
                <td className="px-6 py-4 text-gray-800">03</td>
              </tr>

              {/* TGT */}
              <tr className="border-t bg-gray-50 hover:bg-yellow-50 transition">
                <td></td>
                <td className="px-6 py-4 text-gray-600 pl-10">
                  • TGT
                </td>
                <td className="px-6 py-4 text-gray-800">17</td>
              </tr>

              {/* PRT */}
              <tr className="border-t bg-white hover:bg-yellow-50 transition">
                <td></td>
                <td className="px-6 py-4 text-gray-600 pl-10">
                  • PRT
                </td>
                <td className="px-6 py-4 text-gray-800">26</td>
              </tr>

              {/* Ratio */}
              <tr className="border-t bg-gray-50 hover:bg-yellow-50 transition">
                <td className="px-6 py-4 font-semibold text-blue-900">3</td>
                <td className="px-6 py-4 font-medium text-gray-700">
                  Teachers Section Ratio
                </td>
                <td className="px-6 py-4 text-gray-800 font-semibold">
                  46 : 2
                </td>
              </tr>

            </tbody>

          </table>
        </div>
      </div>
    </section>
  );
}

export default StaffTeaching;